import React, { useState } from 'react';
import AthleteLayout from './AthleteLayout';
import SkisSection from './SkisSection';
import RacesSection from './RacesSection';
import TestsSection from './TestsSection';
import TeamsSection from './TeamsSection';
import SkiInfoSection from './SkiInfoSection'
import ProfileSection from './ProfileSection';
import BugReportPage from './BugReportPage';
import CoachTeamsSection from './CoachTeamsSection';
import CoachLayout from './CoachLayout';
import CoachTeamsSearchSection from './CoachTeamsSearchSection';
import WaxingDiarySection from './WaxingDiarySection';
import WaxTestsSection from './WaxTestsSection';
import CoachSkiFleetSection from './CoachSkiFleetSection';
import { useAuth } from '../AuthContext';

export default function Dashboard() {
  const { user, logout } = useAuth();
  const isCoach = user?.role === 'coach' || user?.role === 'both';
  const [selected, setSelected] = useState(isCoach ? 'my-teams' : 'skis');

  let content;
  let Layout = AthleteLayout;
  if (isCoach) {
    Layout = CoachLayout;
    if (selected === 'my-teams') content = <CoachTeamsSection user={user} logout={logout} selected={selected} />;
    else if (selected === 'search-teams') content = <CoachTeamsSearchSection user={user} logout={logout} selected={selected} />;
    else if (selected === 'waxing-diary') content = <WaxingDiarySection />;
    else if (selected === 'wax-tests') content = <WaxTestsSection />;
    else if (selected === 'ski-fleet') content = <CoachSkiFleetSection />;
    else if (selected === 'profile') content = <ProfileSection />;
    else if (selected === 'report-bug') content = <BugReportPage />;
  } else {
    if (selected === 'skis') content = <SkisSection user={user} logout={logout} />;
    else if (selected === 'races') content = <RacesSection />;
    else if (selected === 'tests') content = <TestsSection />;
    else if (selected === 'teams') content = <TeamsSection />;
    else if (selected === 'ski_info') content = <SkiInfoSection />;
    else if (selected === 'report-bug') content = <BugReportPage />;
    else if (selected === 'profile') content = <ProfileSection />;
  }

  return (
    <Layout selected={selected} onSelect={setSelected}>
      {content}
    </Layout>
  );
} 